"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Indicator;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
/**
 * Indicator icon
 *
 * @displayName Indicator (Web)
 * @class Indicator
 * @public
 */
function Indicator(_ref) {
  let {
    icon,
    background
  } = _ref;
  if (!(!!icon && !!background)) return null;
  const Icon = icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(background, 'panel-indicator')
  }, /*#__PURE__*/_react.default.createElement(Icon, null));
}
Indicator.propTypes = {
  /** Name of the icon to display. */
  icon: _propTypes.default.elementType,
  /** Background class to use. */
  background: _propTypes.default.string
};